import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type User from "./User";

@Model()
class UserRequest extends ApplicationRecord {
  static jsonapiType = "user_requests";

  @Attr() action: string;

  @Attr() approved: boolean;

  @Attr({ persist: false }) createdAt: string;

  @Attr() email: string;

  @Attr() errorMessages: string;

  @Attr() firstName: string;

  @Attr() lastName: string;

  @Attr({ persist: false }) matchingUsers: string[];

  @Attr({ persist: false }) name: string;

  @Attr() notes: string;

  @Attr() organisationTeamIds: number[];

  @Attr() phoneNumber: string;

  @BelongsTo() requester: User;

  @Attr({ persist: false }) reviewedAt: string;

  @BelongsTo() reviewer: User;

  @Attr() team: string;

  @BelongsTo() user: User;
}

export default UserRequest;
